<template>
  <Modal @close="closeModal">
    <template #content>
      <img class="pickup-detail-img" :src="imgSrc" />
    </template>
  </Modal>
</template>

<script lang="ts">
import { defineComponent, onMounted, onUnmounted, SetupContext } from "vue";
import Modal from "@/components/Modal.vue";

type Props = {
  imgSrc: String;
};

export default defineComponent({
  name: "PickupModal",
  components: {
    Modal,
  },
  props: {
    imgSrc: {
      type: String,
      default: "",
    },
  },
  emits: ["img-src", "close"],
  setup(props: Props, context: SetupContext) {
    onMounted(() => {});

    onUnmounted(() => {});

    function closeModal() {
      context.emit("close");
    }

    return {
      closeModal,
    };
  },
});
</script>

<style scoped>
.modal-content > .pickup-detail-img {
  width: 95%;
}

.pickup-detail-img {
  background-color: white;
}
</style>
